<template>
<div class="container">
    <div class="banner" :style="'background-image:url('+ bannerUrl +')'">
      <Btnav></Btnav>  
      <!-- <Nav></Nav>   -->
    </div>
  <!--介绍-->
  <!-- <div class="middle">
    <div class="introduce">
      <div class="title">{{title}}</div>
      <div class="detail" v-html="detail">
       
      </div>
    </div>
  </div> -->
  <!--底部-->
     <!-- <Footer></Footer> -->
     <Btfooter></Btfooter>
  </div>
</template>
<script>
import Btnav from '../../components/dashu/nav';
import Btfooter from '../../components/dashu/footer';
import Footer from '../../components/Footer'
import Nav from '../../components/Nav'
export default {
  components:{Nav,Btnav,Footer,Btfooter},
  name:'Enter',
  data(){
    return{
      title:'',
      bannerUrl:'',
      detail:''
    }
  },
  created(){
    //  this.$http.post('/api/about/getInfo', {

    //       }).then( (res)=> {
    //       // console.log(res.data.data.about)
    //         var code=res.data.code;
    //         if(code===0){
    //          this.title=res.data.data.about.title
    //          this.bannerUrl = res.data.data.banner
    //          this.detail= res.data.data.about.content
    //         }
    //       }).catch(function (error) {
    //     //  console.log(error);
    //  });
  }
}
</script>
<style scoped>
body{
  position: relative;
  /* background-color: rgb(244, 247, 250) */
}
.container{
 background-color:rgb(244,247,250);
 min-width: max-content;
 min-width: -moz-max-content;
}
.banner{
  overflow: hidden !important;
}
.banner{
  position: relative;
  background-image: url('../../assets/banner1.png');
  width: 100%;
  min-width: 1200px;
  height: 366px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.middle{
  width: 1200px;
  margin: 0 auto;
  background-color: rgb(255, 255, 255);
  margin-bottom: -330px;
  padding-bottom: 450px;
  
}
.introduce{
 width:1037px;
 margin: 0 auto;
 padding-top: 50px;
}
.introduce .title{
  font-size: 28px;
  text-align: center;
  font-weight: bolder;
  color: rgb(64, 64, 64)
}
.detail p{
  font-size: 18px;
  color:rgb(89, 89, 89);
 
  line-height: 50px;
  text-indent:36px;
}
.detail p:nth-child(1){
   margin-top:40px;
}
.title_detail{
  font-size: 18px;
   color:rgb(246, 170, 0);
}

</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Enter.vue